/* eslint-disable */
import React from 'react';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Slim from '../../assets/images/slim.webp';
import MidSized from '../../assets/images/midSized.webp';
import PlusSized from '../../assets/images/plusSized.webp';
import Curvy from '../../assets/images/curvy.webp';
import SlimMale from '../../assets/images/slim-men.webp';
import MidSizedMale from '../../assets/images/midsized-men.webp';
import PlusSizedMale from '../../assets/images/plussized-men.webp';
import CurvyMale from '../../assets/images/curvy-men.webp';
import { BodyTypeCard } from './components/BodyCard';
import styles from './style.module.scss';

interface BodyType {
  label: string;
  image: JSX.Element;
}

function Page() {
  const bodyType = useStore((state) => state.bodyType);
  const setBodyType = useStore((state) => state.setBodyType);
  const { onNext, onPrev, currentIndex } = useNav();
  const gender = useStore((state) => state.gender);

  const bodyTypes: BodyType[] = [
    {
      label: 'Slim',
      image: <img src={gender === 'Male' ? SlimMale : Slim} alt='slim-body-type' />,
    },
    {
      label: 'Mid-sized',
      image: <img src={gender === 'Male' ? MidSizedMale : MidSized} alt='mid-sized-body-type' />,
    },
    {
      label: 'Plus-sized',
      image: <img src={gender === 'Male' ? PlusSizedMale : PlusSized} alt='plus-sized-body-type' />,
    },
    {
      label: 'Curvy',
      image: <img src={gender === 'Male' ? CurvyMale : Curvy} alt='curvy-body-type' />,
    },
  ];

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.bodyType.title')}</Title>
        <Text className='description' size='m' medium style={{ padding: '0 35px' }}>
          {t('onboarding.bodyType.subTitle')}
        </Text>
      </div>

      <div className={styles.bodyCards}>
        {bodyTypes.map((item) => (
          <BodyTypeCard
            key={item.label}
            bodyType={item}
            isSelected={bodyType === item.label}
            onSelect={() => {
              setBodyType(item.label);
              Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
                page: 'body-type',
                answer: item.label,
              });
              onNext();
            }}
          />
        ))}
      </div>
    </div>
  );
}
export default Page;
